import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a374f96c&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a374f96c')) {
      api.createRecord('a374f96c', component.options)
    } else {
      api.reload('a374f96c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a374f96c&", function () {
      api.rerender('a374f96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/index.vue"
export default component.exports